export class InterviewGuideReminder {
    companyId: string;
    personId: string;
    jobId: string;
    date: Date;
    completed = false;

    constructor(obj: any) {
        Object.assign(this, obj);
    }
}
